import { Flex, useToast } from '@chakra-ui/react';
import axios from 'axios';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppointment } from '../../../../../../hooks/appointment';
import { showAppointmentsService } from '../../../../../../services/Appointments/ShowAppointmentsService';
import { showTitularUsersService } from '../../../../../../services/Users/ShowTitularUsersService';
import { translateError } from '../../../../../../utils/errors';
import { DefaultLayout } from '../../../../_layout/DefaultLayout';
import AppointmentDetailsData from './components/AppointmentDetailsData';
import { AppointmentDetailsInfo } from './components/AppointmentDetailsInfo';

interface ILocationState {
  appointmentId: string;
}

export const AppointmentDetails = (): JSX.Element => {
  const toast = useToast();
  const { handleAppointment, appointment } = useAppointment();

  const {
    state: { appointmentId },
  } = useLocation<ILocationState>();

  useEffect(() => {
    async function loadAppointment(): Promise<void> {
      try {
        const appointmentData = await showAppointmentsService(appointmentId);
        const titularUser = await showTitularUsersService(
          appointmentData.userId,
        );

        handleAppointment({ ...appointmentData, titularUser });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status !== 401) {
          toast({
            title: 'Falha ao carregar dados',
            description:
              translateError({ message: err.response?.data.message }) ||
              'Ocorreu um erro ao carregar os detalhes da ordem de serviço, tente novamente.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            variant: 'subtle',
            position: 'top-right',
          });
        }
      }
    }

    loadAppointment();

    return () => handleAppointment(undefined);
  }, [appointmentId, handleAppointment, toast]);

  return (
    <DefaultLayout>
      {appointment && (
        <Flex direction="column" w="100%">
          <AppointmentDetailsInfo minW="510px" />

          <AppointmentDetailsData flex="1" mt="8" minW="510px" />
        </Flex>
      )}
    </DefaultLayout>
  );
};
